import { Capacitor } from "@capacitor/core";

const deviceKey = "wenjing_native_device_id";

export function authDeviceId() {
  let value = localStorage.getItem(deviceKey) || "";
  if (!value) {
    value = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(deviceKey, value);
  }
  return value;
}

function webDeviceName() {
  const agent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(agent)) return "iPhone/iPad 网页";
  if (/Android/i.test(agent)) return "Android 网页";
  if (/Macintosh|Mac OS/i.test(agent)) return "macOS 网页";
  if (/Windows/i.test(agent)) return "Windows 网页";
  return "网页浏览器";
}

export function authClientContext() {
  const native = Capacitor.isNativePlatform(), platform = Capacitor.getPlatform();
  return { clientType: native ? "native_app" : "web", deviceId: authDeviceId(), deviceName: native ? `${platform === "ios" ? "iOS" : platform === "android" ? "Android" : platform} APP` : webDeviceName() };
}
